<template>
  <div>
    <div
      class="row items-start"
      :class="compactView ? 'q-col-gutter-sm' : 'q-col-gutter-md'"
    >
      <model-form-checkbox
        field="config.footerShowCircuitName"
        value-type="Boolean"
        :class="compactView ? 'col-12' : 'col-6 col-sm-3'"
        label="Show Circuit Name in Footer"
      />
      <model-form-select
        field="config.footerVerticalAlignment"
        value-type="String"
        :class="compactView ? 'col-12 q-pb-xs' : 'col-3'"
        label="Vertical Alignment"
        :options="verticalAlignOptions"
        map-options
        emit-value
      />
      <model-form-select
        field="config.footerHorizontalAlignment"
        value-type="String"
        :class="compactView ? 'col' : 'col-3'"
        label="Text Alignment (Desktop)"
        :options="textAlignOptions"
        map-options
        emit-value
      />
      <model-form-select
        field="config.footerHorizontalMobileAlignment"
        value-type="String"
        :class="compactView ? 'col' : 'col-3'"
        label="Text Alignment (Mobile)"
        :options="textAlignOptions"
        map-options
        emit-value
      />
    </div>
    <global-widget-block-table
      class="q-mb-md"
      :global-widget="globalWidget"
      :compact-view="compactView"
      :type="GLOBAL_WIDGET_TYPES.FOOTER"
    />
  </div>
</template>

<script>
import { IMAGE_POSITION_OPTIONS, IMAGE_TRANSFORM_OPTIONS } from 'src/models/carousel/Carousel'
import GlobalWidget, { GLOBAL_WIDGET_TYPES, TEXT_ALIGN_OPTIONS, verticalAlignOptions } from 'src/models/global-widget/GlobalWidget'
import { backgroundAttachmentOptions, backgroundRepeatOptions, colorOptions } from 'src/models/page/Section'
import GlobalWidgetBlockTable from 'src/modules/admin/global-widget/GlobalWidgetBlockTable'

export default {
  name: 'GlobalWidgetFooterEditor',
  components: {
    GlobalWidgetBlockTable
  },
  props: {
    globalWidget: {
      type: GlobalWidget,
      required: true
    },
    compactView: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      addNewOptionError: null,
      pagination: {
        page: 1,
        rowsPerPage: 0
      }
    }
  },
  computed: {
    footerBlockColumns () {
      if (this.compactView) {
        return [
          { name: 'name', align: 'left', label: 'Name', field: footerBlock => footerBlock[this.localizeKey('name')] || footerBlock.name, sortable: true },
          { name: 'actions', label: 'Actions' }
        ]
      }
      return [
        { name: 'name', align: 'left', label: 'Name', field: footerBlock => footerBlock[this.localizeKey('name')] || footerBlock.name, sortable: true },
        { name: 'width', align: 'left', label: 'Width', field: 'width', sortable: false },
        { name: 'displayItems', align: 'left', label: 'Display Items', field: footerBlock => footerBlock.displayItems, sortable: true },
        { name: 'actions', label: 'Actions' }
      ]
    }
  },
  created () {
    _.extend(this, {
      textAlignOptions: this.$mh.asOptions(TEXT_ALIGN_OPTIONS.ALL),
      colorOptions: _.filter(colorOptions, opt => opt.value !== 'default'),
      IMAGE_TRANSFORM_OPTIONS,
      IMAGE_POSITION_OPTIONS,
      backgroundRepeatOptions,
      backgroundAttachmentOptions,
      verticalAlignOptions,
      GLOBAL_WIDGET_TYPES
    })
  },
  mounted () {
    this.$mh.setCustomPageStyles(this.globalWidget.transformedStyles)
  },
  unmounted () {
    this.$mh.setCustomPageStyles(null)
  }
}
</script>
